import React from 'react';
import Variable from 'components/Tvendo/Setting/Variable/List.js';

export default function () {
  return <Variable />;
}
